/* eslint-disable no-unused-vars */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import pt_common from "./locales/pt/common.json";
import pt_header from "./locales/pt/header.json";
import pt_footer from "./locales/pt/footer.json";
import pt_homepage from "./locales/pt/homepage.json";
import pt_aboutuspage from "./locales/pt/aboutuspage.json";
import pt_downloadspage from "./locales/pt/downloadspage.json";
import pt_newspage from "./locales/pt/newspage.json";
import pt_recruitmentpage from "./locales/pt/recruitmentpage.json";
import pt_contactspage from "./locales/pt/contactspage.json";
import pt_slider from "./locales/pt/slider.json";
import pt_services from "./locales/pt/services.json";
import pt_account from "./locales/pt/account.json";
import pt_productscontent from "./locales/pt/productscontent.json";

import en_common from "./locales/en/common.json";
import en_header from "./locales/en/header.json";
import en_footer from "./locales/en/footer.json";
import en_homepage from "./locales/en/homepage.json";
import en_aboutuspage from "./locales/en/aboutuspage.json";
import en_downloadspage from "./locales/en/downloadspage.json";
import en_newspage from "./locales/en/newspage.json";
import en_recruitmentpage from "./locales/en/recruitmentpage.json";
import en_contactspage from "./locales/en/contactspage.json";
import en_slider from "./locales/en/slider.json";
import en_services from "./locales/en/services.json";
import en_account from "./locales/en/account.json";
import en_productscontent from "./locales/en/productscontent.json";

import es_common from "./locales/es/common.json";
import es_header from "./locales/es/header.json";
import es_footer from "./locales/es/footer.json";
import es_homepage from "./locales/es/homepage.json";
import es_aboutuspage from "./locales/es/aboutuspage.json";
import es_downloadspage from "./locales/es/downloadspage.json";
import es_newspage from "./locales/es/newspage.json";
import es_recruitmentpage from "./locales/es/recruitmentpage.json";
import es_contactspage from "./locales/es/contactspage.json";
import es_slider from "./locales/es/slider.json";
import es_services from "./locales/es/services.json";
import es_account from "./locales/es/account.json";
import es_productscontent from "./locales/es/productscontent.json";

import fr_common from "./locales/fr/common.json";
import fr_header from "./locales/fr/header.json";
import fr_footer from "./locales/fr/footer.json";
import fr_homepage from "./locales/fr/homepage.json";
import fr_aboutuspage from "./locales/fr/aboutuspage.json";
import fr_downloadspage from "./locales/fr/downloadspage.json";
import fr_newspage from "./locales/fr/newspage.json";
import fr_recruitmentpage from "./locales/fr/recruitmentpage.json";
import fr_contactspage from "./locales/fr/contactspage.json";
import fr_slider from "./locales/fr/slider.json";
import fr_services from "./locales/fr/services.json";
import fr_account from "./locales/fr/account.json";
import fr_productscontent from "./locales/fr/productscontent.json";

i18n.use(initReactI18next).init({
  resources: {
    pt: {
      common: pt_common,
      header: pt_header,
      footer: pt_footer,
      homepage: pt_homepage,
      aboutuspage: pt_aboutuspage,
      downloadspage: pt_downloadspage,
      newspage: pt_newspage,
      recruitmentpage: pt_recruitmentpage,
      contactspage: pt_contactspage,
      slider: pt_slider,
      services: pt_services,
      account: pt_account,
      productscontent: pt_productscontent,
    },
    en: {
      common: en_common,
      header: en_header,
      footer: en_footer,
      homepage: en_homepage,
      aboutuspage: en_aboutuspage,
      downloadspage: en_downloadspage,
      newspage: en_newspage,
      recruitmentpage: en_recruitmentpage,
      contactspage: en_contactspage,
      slider: en_slider,
      services: en_services,
      account: en_account,
      productscontent: en_productscontent,
    },
    es: {
      common: es_common,
      header: es_header,
      footer: es_footer,
      homepage: es_homepage,
      aboutuspage: es_aboutuspage,
      downloadspage: es_downloadspage,
      newspage: es_newspage,
      recruitmentpage: es_recruitmentpage,
      contactspage: es_contactspage,
      slider: es_slider,
      services: es_services,
      account: es_account,
      productscontent: es_productscontent,
    },
    fr: {
      common: fr_common,
      header: fr_header,
      footer: fr_footer,
      homepage: fr_homepage,
      aboutuspage: fr_aboutuspage,
      downloadspage: fr_downloadspage,
      newspage: fr_newspage,
      recruitmentpage: fr_recruitmentpage,
      contactspage: fr_contactspage,
      slider: fr_slider,
      services: fr_services,
      account: fr_account,
      productscontent: fr_productscontent,
    },
  },
  lng: "pt", // idioma inicial
  fallbackLng: "en", // fallback se faltar alguma key
  ns: [
    "common",
    "header",
    "products",
    "account",
    "errors",
    "homepage",
    "aboutuspage",
    "downloadspage",
    "newspage",
    "recruitmentpage",
    "contactspage",
    "slider",
    "services",
    "account",
    "productscontent",
  ],
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
